<div class="skiplinks navigator visually-hidden-focusable">
  <a href="javascript:void(0)" (click)="goToMainContent.emit()">{{
    "GOTO_MAIN" | translate
  }}</a>
</div>
